import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Tooltip, IconButton } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { FormatoFechaIso } from '../../../utils/FormatFecha';
import MDetalleReferencia from '../DReferencias';
const columns = [
    { id: "paquete", minWidth: 150, align: "center", label: 'Paquete' },
    { id: "claveViaje", minWidth: 50, align: "center", label: 'Clave de viaje' },
    { id: "noReferencias", minWidth: 50, align: "center", label: 'No. Referencias' },
    { id: "accion", minWidth: 50, align: "center", label: '' },
];

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

export default function TGruposCalendario({ rows = [] }) {
    const history = useHistory()
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }
    const onDetalle = (row) => {
        history.push({
            pathname: `/Grupo/${row?.paquete?.Nombre}/${FormatoFechaIso({date: row?.FechaViaje, formato: "MMddyyyyHHmmss"})}`
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    <TableCell align='center'>
                                        {`${row?.Nombre}`}
                                    </TableCell>
                                    <TableCell align="center">
                                        {`${row?.ClaveViaje}`}
                                    </TableCell>
                                    <TableCell align="center">
                                        {`${row?.TotalReferencias}`}
                                    </TableCell>
                                    <TableCell>
                                        <MDetalleReferencia
                                                ClaveViaje={row?.ClaveViaje}
                                        />
                                        {/* <Tooltip title="Ver detalle">
                            
                                            <IconButton
                                                aria-label="Ver detalle"
                                                onClick={() => { onDetalle(row) }}
                                            >
                                                <AssignmentIcon />
                                            </IconButton>
                                        </Tooltip> */}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}